import { api } from '@setplex/tria-api'
import { combine, createEvent, sample } from 'effector'
import { not } from 'patronum'
import { moviesPurchasedEntityModel } from '~/entities/movies/purchased'

export const loadGridPurchasedMovies = createEvent()

sample({
  clock: loadGridPurchasedMovies,
  filter: not(api.vods.getPurchasedVodsGridFx.pending),
  target: api.vods.getPurchasedVodsGridFx,
})

export const $isGridPurchasedMoviesLoading = combine(
  {
    purchasedMoviesLoading: api.vods.getPurchasedVodsGridFx.pending,
    purchasedMovies: moviesPurchasedEntityModel.$purchasedVodsGrid,
  },
  ({ purchasedMoviesLoading, purchasedMovies }) =>
    !purchasedMovies && purchasedMoviesLoading
)

export const loadMoreGridPurchasedMovies = createEvent()

sample({
  clock: loadMoreGridPurchasedMovies,
  filter: not(api.vods.getPurchasedVodsGridFx.pending),
  fn: () => null,
  target: moviesPurchasedEntityModel.loadMorePurchasedVodsGrid,
})
